import ActivityManager from "@/activity/ActivityManager";
import SessionManager from "@/utils/SessionManager";
import {getMenu} from "@/components/dashboard/menu/MenuContent";
import FormsActions from "@/components/forms/FormsActions";
import BookHealthcheck from "@/server/com/silkplm/model/healthcheck/BookHealthcheck";
import Delegation from "@/server/com/silkplm/model/plm/Delegation";
import tr from "@/utils/Tr";

const UserEditPanel = () => require("@/components/forms/customizations/plm/UserEditPanel");
const UserNotificationsPanel  = () => require("@/components/notifications/UserNotificationsPanel");
// const Delegations = () => require("@/components/forms/customizations/plm/Delegations");

export const RIGHT_MENU = () => [
    {
        id: 'r-acc',
        label: tr("MyAccount","My Account"),
        icon: "user-alt",
        open:true,
        items:[
            {
                id: 'notifications',
                label: tr("Notifications","Notifications"),
                icon: "comment-alt-lines",
                action: async () =>{ return ActivityManager.showActivity(UserNotificationsPanel)},
                permission: null
            },
            {
                id: 'profile',
                label: $tr("My Profile","My Profile"),
                icon: "user-check",
                action: async () =>{ return ActivityManager.showActivity(UserEditPanel)},
                permission: null
            },
            // ustawienia użytkownika - póki co jest tu tylko opcja na włączenie/wyłączeniu streamingu - więc wyłączam
            // {
            //     id: 'user-settings',
            //     label: tr("Settings","Settings"),
            //     icon: "user-cog",
            //     action: async () =>{
            //         let settings = await Rpc.Session.loadUserSettings();
            //         let editWindow = await FormsActions.edit(settings);
            //         await  editWindow.getResult();
            //         SessionManager.loadUserSettings();
            //
            //     },
            //     permission: null
            // },

            {
                id: 'delegation',
                label: tr("deputies","Deputies"),
                icon: "users-gear",
                action: async () => {
                    await FormsActions.showList(Delegation, {});
                },
                permission: null
            },
            {
                id: 'sign-out',
                label: tr("signOut","Sign out"),
                icon: "power-off",
                action: async () =>{ return SessionManager.signOut()},
                permission: null
            },
        ]
    },
];



/**
 * @returns {Menu}
 */

export async function getRightMenu() {
    return RIGHT_MENU();
}
